import request from './index'
class echeo{
    static arr(params){
        return request('get','/statistics/info',params,'o')
    }
}
class word {    //词库管理相关接口
   static checkpoint(params){
        return request('get', '/word/checkpoint',params,'no') //词库关卡列表
    }
    static delete(params){
        return request('post',"/word/delete",params) //删除词语
    }
    static list(params){
        return request('get','/word/list',params,'no','page') //词库列表
    }
    static save(params){
        return request('post', '/word/save',params) //新增/修改词语
    }
   
} 
class article { // 文章管理相关接口
    static delete(params){
        return request('post','/article/delete',params) //删除文章
    }
    static list(params){
        return request('get','/article/list',params,'no','page')    //文章列表
    }
    static save(params){
        return request('post','/article/save',params) //新增/修改文章
    }
    static star(params){
        return request('get','/article/star',params,'no')    //文章星级列表
    }
    static score(params){
        return request('get','/article/score/list',params,'no')
    }
}
class startupPage {     //启动页相关列表
    static list(params){
        return request('get','/startupPage/list',params,'no') //启动页列表
    }
    static save(params){
        return request('post','/startupPage/save',params) //新增/修改/发布/下架
    }
    static delete(params){
        return request('post','/startupPage/delete',params)
    }
}
class composition { //作文题目相关列表
    static list(params){
        return request('get','/composition/list',params,'no')  // 作文题目列表
    }
    static save(params){
        return request('post','/composition/save',params,)
    }
    static delete(params){
        return request('post','/composition/delete',params)
    }
}
class awesomeComposition{ //优秀作文列表
    static list(params){
        return request('get','/awesomeComposition/list',params,'no')
    }
    static save(params){
        return request('post','/awesomeComposition/save',params,)
    }
    static delete(params){
        return request('post','/awesomeComposition/delete',params)
    }
}
class classNmae{
    static class(params){
        return request('get','/class/list',params,'o')
    }
}

class priceConfig{
    static set(params){
        return request('post','/config/updateOrderAmount',params)
    }
}

export default {word,article,startupPage,composition,awesomeComposition,classNmae,echeo, priceConfig}